import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const slides = [
  {
    image: '/assets/images/banner01.png',
    title: 'EMBEDDED SYSTEMS',
    subtitle: "Operational efficiency, Reduces Costs, and Mitigates risks across industries Worldwide",
    buttonText: 'EXPLORE SERVICES',
    buttonLink: '/services',
  },
  {
    image: '/assets/images/banner02.png',
    title: 'FLEET TRACKING',
    subtitle: 'Real-Time Monitoring & Analytics Solutions',
    buttonText: 'EXPLORE PRODUCTS',
    buttonLink: '/products',
  },
];

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const autoPlayRef = useRef(null);

  const startAutoPlay = useCallback(() => {
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    autoPlayRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
  }, []);

  useEffect(() => {
    startAutoPlay();
    return () => clearInterval(autoPlayRef.current);
  }, [startAutoPlay]);

  return (
    <div className="w-full pt-16">
      <div className="relative overflow-hidden">
        {slides.map((slide, idx) => (
          <div
            key={idx}
            className={`absolute inset-0 transition-all duration-[1200ms] ease-out ${
              idx === current
                ? 'opacity-100 scale-100 z-10'
                : 'opacity-0 scale-110 z-0 pointer-events-none'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="absolute inset-0 w-full h-full object-cover"
              draggable="false"
            />
            <div className="absolute inset-0 bg-black/50" />
          </div>
        ))}

        {/* Content sets the height; images/overlay fill it via inset-0 above */}
        <div className="relative z-20 max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="py-28 md:py-36 min-h-[480px] flex flex-col items-center justify-center text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight transition-all duration-700">
              {slides[current].title}
            </h1>
            <p className="text-lg md:text-2xl text-gray-200 mb-10 transition-all duration-700">
              {slides[current].subtitle}
            </p>
            <Link
              to={slides[current].buttonLink}
              className="group inline-flex items-center justify-center gap-2 min-w-[240px] h-12 px-8 bg-white text-gray-900 font-bold text-sm tracking-wide uppercase rounded-md hover:bg-gray-100 transition-all duration-300"
            >
              <span>{slides[current].buttonText}</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;